export const Delimiter = () => {
  return <div className="h-px w-full bg-v2blueGray-100 bg-opacity-[0.12]" />;
};
